import { PROCESSING_STATUS_COLORS } from '../../data/facilitiesData';

// Operational / Under Rehabilitation / Temporarily Closed pill used by the
// Processing, Artificial Insemination and Breeding Centers tables
export default function OperationalStatusBadge({ status }) {
  const color = PROCESSING_STATUS_COLORS[status] || '#6b7280';
  return (
    <span
      className="inline-flex items-center justify-center rounded-[20px] px-[12px] py-[5px] text-[11px] font-medium"
      style={{ background: `${color}18`, color, border: `1px solid ${color}40` }}
    >
      {status}
    </span>
  );
}
